import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {PackingInfoStatusType} from "../../../../deliveries/types/packing-info-status.type";

require('./service-packages-info.scss');
@Component({
  standalone: false,
  selector: 'app-service-packages-info',
  templateUrl: './service-packages-info.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicePackagesInfoComponent implements OnInit, OnChanges {
  @Input() isPacked: any;
  @Input() packageList: any;
  @Input() packingInfo: any;
  @Input() packedDate: any;
  @Input() hasMissingPackages: boolean;

  public packingInfoStatusType: typeof PackingInfoStatusType = PackingInfoStatusType;
  public packingDisplayStatus: string;

  constructor() {
  }

  ngOnInit() {
    this._setDisplayStatus();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  private _setDisplayStatus() {
    this.packingDisplayStatus = this.packingInfo?.status ||
      (this.isPacked ? this.packingInfoStatusType.Packed : this.packingInfoStatusType.NotPacked);
  }

}
